import React from 'react';
import Header from './_header';
import Founder from './_founder';
import Bonus from './_bonus';
import TeamGuest from './_team-guest';
import TeamOfficial from './_team-official';
import TeamAmbassador from './_team-ambassador';

const TeamView = () => {
  return (
    <>
      <Header />
      <Founder />
      <Bonus />
      <TeamOfficial />
      <TeamGuest />
      <TeamAmbassador />
    </>
  );
}

export default TeamView;
